import React from 'react';
import { CircleAlert } from 'lucide-react';
import { Button } from '../ds';

/** A real error (an upload that failed, a clip that's too long): meter-problem, with an icon and words */
export const ErrorNote = ({ children, onDismiss }) => (
  <div role="alert" className="flex items-center gap-space-3 px-space-3 py-space-2 rounded-radius-md bg-base font-text text-small text-ink-soft">
    <CircleAlert size={18} strokeWidth={2.5} aria-hidden="true" className="flex-none text-meter-problem" />
    <span className="flex-1 min-w-0 py-space-1">
      <span className="font-bold text-meter-problem">Couldn't do that. </span>
      {children}
    </span>
    {onDismiss && <Button variant="text" onClick={onDismiss} className="flex-none">Dismiss</Button>}
  </div>
);
